import { BRANCH_CATEGORY_CODES } from './dto/org';
export const BRANCH_MAIN_CATEGORIES = ['opd', 'ipd', 'lab', 'pharmacy'];
export const BRANCH_CATEGORY_TREE = {
    opd: ['dental'],
    ipd: ['er', 'ot', 'maternity', 'dialysis', 'daycare', 'blood_bank'],
    lab: ['radiology', 'blood_bank'],
    pharmacy: [],
};
const KNOWN_CATEGORIES = new Set(BRANCH_CATEGORY_CODES);
const MAIN_CATEGORIES = new Set(BRANCH_MAIN_CATEGORIES);
export function isBranchMainCategory(code) {
    return MAIN_CATEGORIES.has(code);
}
export function mainCategoriesOffering(sub) {
    return BRANCH_MAIN_CATEGORIES.filter((main) => BRANCH_CATEGORY_TREE[main].includes(sub));
}
export function subCategoriesWithoutMain(codes) {
    const chosen = new Set(codes);
    return codes.filter((code) => KNOWN_CATEGORIES.has(code) && !isBranchMainCategory(code) && !mainCategoriesOffering(code).some((main) => chosen.has(main)));
}
export function inferBranchMainCategories(codes, preferred) {
    const chosen = new Set(codes);
    const added = [];
    for (const orphan of subCategoriesWithoutMain(codes)) {
        const offering = mainCategoriesOffering(orphan);
        if (offering.some((main) => chosen.has(main) || added.includes(main)))
            continue;
        const main = offering.find((candidate) => preferred?.has(candidate)) ?? offering[0];
        if (main)
            added.push(main);
    }
    return added;
}
export function orderBranchCategories(codes) {
    const chosen = new Set(codes.filter((code) => KNOWN_CATEGORIES.has(code)));
    const ordered = [];
    const take = (code) => {
        if (chosen.has(code) && !ordered.includes(code))
            ordered.push(code);
    };
    for (const main of BRANCH_MAIN_CATEGORIES) {
        if (!chosen.has(main))
            continue;
        take(main);
        for (const sub of BRANCH_CATEGORY_TREE[main])
            take(sub);
    }
    for (const main of BRANCH_MAIN_CATEGORIES) {
        for (const sub of BRANCH_CATEGORY_TREE[main])
            take(sub);
    }
    return ordered;
}
export function normaliseBranchCategories(codes, preferred) {
    return orderBranchCategories([...codes, ...inferBranchMainCategories(codes, preferred)]);
}
export function withoutBranchMainCategory(codes, main) {
    const remaining = codes.filter((code) => code !== main);
    const stillOffered = new Set(remaining.filter(isBranchMainCategory).flatMap((kept) => BRANCH_CATEGORY_TREE[kept]));
    return orderBranchCategories(remaining.filter((code) => isBranchMainCategory(code) || stillOffered.has(code)));
}
//# sourceMappingURL=branch-categories.js.map